import orgStrucDlg from './orgStrucDlg.js' // 组织架构dlg

const platformSystem = {
  namespaced: true,
  modules: {
    orgStrucDlg,
  }
}

export default platformSystem
